import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const SelectTemplate = ({ data, onSelect }) => {
  const options = data.map(item => ({
    label: item.name + " (" + item.message_type + ")",
    value: item
  }));

  return (
    <div className="mb-15">
      <label htmlFor="select-template">Template</label>
      <Select
        inputId="select-template"
        ariaLabel="select-template"
        styles={{
          menuList: (base, _) => ({ ...base, maxHeight: 250 }),
          placeholder: (base) => ({ ...base, color: "#595959" }) 
        }}
        className="custom-react-select"
        value=""
        options={options}
        onChange={onSelect}
        placeholder="Select template"
      />
    </div>
  );
};

SelectTemplate.propTypes = {
  data: PropTypes.array,
  onSelect: PropTypes.func
};

export default SelectTemplate;
